import { useAppContext } from "../context/AppContext";

export function useClientInfo() {
  const { clientId, company, financialPeriod } = useAppContext();

  return {
    clientId: clientId || null,
    financialPeriod: financialPeriod || null,

    // map company as client for reports
    client: company || null
  };
}
